/*
I have included the SCSS and bootstrap library by using the npm.
and in this page there is only one component included 
i.e allrouting(where we have done our routing of every page).
*/
import './App.scss';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import "./_reboot.scss"
import AllRouting from './AllRouting';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    import("../node_modules/bootstrap/dist/js/bootstrap.min.js");
  }, []);
  return (   
    <AllRouting />
  );
}

export default App;
